/* eslint-disable i18n-scan/no-inline-content */
import PropTypes from 'prop-types'
import React from 'react'
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary'
// import { fpti } from '../hooks/useTracking';
import ErrorFallback from './ErrorFallback'
// import {fptiTypes} from '../utils/analytics/fpti-constants'

/* 
 Reference - https://github.com/bvaughn/react-error-boundary#readme
  https://kentcdodds.com/blog/use-react-error-boundary-to-handle-errors-in-react  
    
  ErrorFallback component for 'react-error-boundary' module to handle the errors
*/

// const handleError = (name) => (error, componentStack) => {
const handleError = () => () => {
  // const {fptiClick} = useCallback(fpti())
  // TODO: Track through FPTI -> Currently its being tracked through pa.js framework itself
  // fptiClick({ componentName: name, type: fptiTypes.ERROR })
}

const ErrorBoundary = ({ children, onError, FallbackComponent, name }) => (
  <ReactErrorBoundary
    onError={onError(name)}
    FallbackComponent={FallbackComponent}
  >
    {children}
  </ReactErrorBoundary>
)

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  // eslint-disable-next-line react/forbid-prop-types
  FallbackComponent: PropTypes.any,
  onError: PropTypes.func,
  name: PropTypes.string,
}

ErrorBoundary.defaultProps = {
  children: null,
  FallbackComponent: ErrorFallback,
  onError: handleError,
  name: '',
}

export default ErrorBoundary
